import { InputNumber } from 'antd';
import classNames from 'classnames';
import React from 'react';

import './style.scss';

interface IProps {
    minLength?: number;
    maxLength?: number;
    placeholder?: string;
    field: any;
    onBlur?: () => void;
    onFocus?: () => void;
    onChange?: () => void;
    prefix?: string;
    addonAfter?: React.ReactNode | null;
    min?: number;
    max?: number;
    width?: string | number;
    disabled?: boolean;
    isDecimal?: boolean;
    readonly?: boolean;
    className?: string;
    textAlign?: 'right' | 'left';
}

const InputMoney: React.FC<IProps> = ({
    field,
    minLength,
    maxLength,
    placeholder,
    onBlur,
    onFocus,
    onChange,
    prefix,
    addonAfter,
    min,
    max,
    width,
    disabled,
    isDecimal = false,
    readonly = false,
    className = '',
    textAlign = 'left',
}) => {
    const onKeyPress = (e: React.KeyboardEvent) => {
        const specialCharRegex = new RegExp('[0-9]');
        const specialCharRegexDecimal = new RegExp('[0-9.]');
        const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        // const kanaRegExp = new RegExp('[\uff00-\uff9f]');
        // const isKana = kanaRegExp.test(pressedKey);
        // console.log('sdsdds', kanaRegExp.test(pressedKey));
        // console.log('xxxxxx', pressedKey);
        // if (isKana) {
        //     console.log('xxxxx');
        //     field.value = field.slice(0, -1);
        // }
        const checkSpecial = isDecimal ? !specialCharRegexDecimal.test(pressedKey) : !specialCharRegex.test(pressedKey);

        if (checkSpecial) {
            e.preventDefault();
            return;
        }
    };

    const disabledCopyPaste = (e: React.KeyboardEvent) => {
        e.preventDefault();
        return false;
    };

    return (
        <InputNumber
            className={classNames('input-money', className)}
            style={{ width: width, '--textAlign': textAlign }}
            onBlur={onBlur}
            onFocus={() => {
                if (onFocus) onFocus();
            }}
            onChange={onChange}
            minLength={minLength}
            maxLength={maxLength}
            min={min}
            max={max}
            readOnly={readonly}
            placeholder={placeholder}
            disabled={disabled}
            {...field}
            formatter={(value) => `${prefix ? prefix : ''} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={(value) => value?.replace(/￥\s?|(,*)/g, '')}
            addonAfter={addonAfter}
            controls={false}
            onKeyPress={onKeyPress}
            onPaste={disabledCopyPaste}
            inputMode="none"
        />
    );
};

export default React.memo(InputMoney);
